


































import { mapGetters } from 'vuex';
import i18n from '@/locales'
import footerLowiro from './footer-lowiro.vue'

export default {
  components: {
    footerLowiro
  },
  computed: {
    ...mapGetters(['authUser', 'chinaApk']),
    locale(): string {
      return i18n.locale === 'zh-hant' ? 'zh' : i18n.locale;
    },
    googlePlayImgUrl(): NodeRequire {
      return require(`@/assets/google-play-badge_${this.locale}_equalised.svg`)
    },
    iosImgUrl(): NodeRequire {
      return require(`@/assets/apple-app-store_${this.locale}_equalised.svg`)
    }
  }
}
